<modal #modal
        modalClass="modal-lg modal-md"
        [hideCloseButton]="false"
        [closeOnEscape]="false"
        [closeOnOutsideClick]="false"
        (onClose)="handleClose()">
 
    <modal-header class="w-100 text-center">
        <h4 class="h4-responsive modal-title text-center">Login Required</h4>
    </modal-header>
 
    <modal-content class="container-fluid d-block">
        <div class="row">
            <div class="col text-center">
                <p>You've requested access to a secure resource or you have been logged out.</p>
                <p>Please login again.</p>
            </div>
        </div>
        <div class="row">
            <div class="col text-center">
                <input type="button" class="btn btn-primary" value="Client Login" (click)="goToClientLogin()" />
                <input type="button" class="btn btn-primary" value="Therapist Login" (click)="goToAdminLogin()" />
            </div>
        </div>
    </modal-content>
 
    <modal-footer></modal-footer>
        
</modal>


// WEBPACK FOOTER //
// ./src/app/login/login-dialog/login-dialog.component.html